module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-2-2.b5d201f8.png";